/**
 * ClazzController.java 对应的 model
 */

import Model from './model'
// import _ from 'lodash'
import { ClazzInfoFlags, ResourceState, ClazzUserState } from 'core/constant'
const model = new Model()

class Clazz {

    /**
     * 获取班级列表
     * @returns 班级信息
     */
    static getClazzs() {
        return model.postForm('clazz/getClazzs', { clazzInfoFlags: ClazzInfoFlags.CLAZZ_BASE | ClazzInfoFlags.CLAZZ_USER_TYPE | ClazzInfoFlags.CLAZZ_UNTEST_PAPERS | ClazzInfoFlags.CLAZZ_UNREAD_REPORTS | ClazzInfoFlags.CLAZZ_RESENT_TIMES })
    }

    /**
     * 获取当前班级信息
     * @returns 班级信息
     */
    static getClazzById(clazzId) {
        return model.postForm('clazz/getClazzById', {
            clazzId,
            clazzInfoFlags: ClazzInfoFlags.CLAZZ_BASE | ClazzInfoFlags.CLAZZ_USER_TYPE | ClazzInfoFlags.CLAZZ_NOTICES
        })
    }

    /**
     * 获取班级人员
     * @param params
     * @returns 班级人员信息
     */
    static getClazzMembers(params) {
        // int clazzId;
        // Integer userId;// 不为空时表示一个用户
        // String key;// 查询关键字
        // int clazzMemberType;// 获取操作的成员类型，参考ClazzMemberType
        // Page page;// 分页使用
        return model.post('clazz/getClazzMembers', params)
    }

    /**
     * 获取班级人员详情
     * @param clazzId
     * @param userId
     * @returns 班级人员详情
     */
    static getClazzMember(clazzId, userId) {
        return model.post('clazz/getClazzMember', { clazzId, userId })
    }

    /**
     * 获取班级试卷信息
     * @param params
     * @returns {*}
     */
    static getClazzPapers(params) {
        return model.post(`clazz/getClazzPapers`, params)
    }

    /**
     * 获取班级试卷详情
     * @param clazzId
     * @param paperId
     * @returns {*}
     */
    static getClazzPaperInfo(clazzId, paperId) {
        return model.post(`clazz/getClazzPaperInfo?clazzId=${clazzId}&paperId=${paperId}`)
    }

    /**
     * 获取当前班级试卷 id 列表 (用于对比操作)
     * @returns 班级试卷信息
     */
    static getClazzPaperIds(clazzId) {
        return model.post(`clazz/getClazzPaperIds`, { clazzId })
    }

    /**
     * 删除班级试卷
     * @param clazzId
     * @param paperId
     * @returns
     */
    static deleteClazzPaper(clazzId, paperId) {
        return model.postForm('clazz/deleteClazzPaper', { clazzId, paperId })
    }

    /**
     * 修改群组成员状态 (同意成员加入群组, 拒绝成员加入群组, 移除群成员)
     * @param clazzId 群组 id
     * @param memberIds 群组成员 id 列表
     * @param state 参考常量 ClazzUserState
     * @returns {*}
     */
    static updateMemberState({ clazzId, memberIds, state }) {
        const _data = []
        memberIds.forEach((userId) => _data.push({ clazzId, userId }))
        return model.post('clazz/updateClazzUserStates?state=' + state, _data)
    }

    /**
     * 获取班级内没有参加考试的学生列表
     *
     * @param params
     * @return
     */
    static getUnReportStudents(params) {
        return model.post(`clazz/getUnReportStudents`, params)
    }

    /**
     * 发送考试通知
     *
     * @param req
     * clazzId
     * paperId
     * userIds;// 带通知的学生列表
     * invitationType; // 参考 UserInvitationType 常量
     * sentType;
     * @return
     */

    static saveClazzPaperInvitation(req) {
        return model.post('clazz/saveClazzPaperInvitation', req)
    }

    /**
     * 获取班级报告
     *
     * @param params
     * @return
     */
    static getClazzPaperReports(params) {
        return model.post('clazz/getClazzPaperReports', params)
    }

    /**
     * 创建群组
     *
     * @param clazzId
     * @param clazzName
     * @param clazzLogo
     * @param clazzDesc
     * @param perm 权限
     * @return
     */

    static createClazz(opts) {
        return model.post('clazz/createClazz', opts)
    }

    /**
     * 搜索群组
     *
     * @param condition
     * @return
     */

    static getClazzsByCondition(condition) {
        return model.post('clazz/open/getClazzsByCondition', condition)
    }

    /**
     * 加入群组
     * @param clazzId
     * @returns {*}
     */
    static saveClazzUser(clazzId) {
        return model.post(`clazz/saveClazzUser?clazzId=${clazzId}`)
    }

    /**
     * 布置作业
     * @param params 参数
     * @returns {*}
     */
    static saveClazzPapers(params) {
        const processParams = {}
        processParams.clazzId = params.groupId
        processParams.paperIds = [ params.paperId ]
        processParams.description = params.description
        processParams.beginDate = params.beginTimestamp
        processParams.endDate = params.endTimestamp
        processParams.userIds = params.memberIdList
        processParams.invitationType = params.invitationType
        processParams.syncClazzIds = params.syncedGroupIdList
        processParams.userNoticed = params.userNoticed
        return model.post('clazz/saveClazzPapers', processParams)
    }

    /**
     * 修改作业
     *
     * @param params 参数
     * @return
     */
    static updateClazzPaper(params) {
        const processParams = {}
        processParams.clazzId = params.groupId
        processParams.paperId = params.paperId
        processParams.description = params.description
        processParams.beginDate = params.beginTimestamp
        processParams.endDate = params.endTimestamp
        processParams.userNoticed = params.userNoticed
        if (params.memberIdList.length !== 0) {
            processParams.invitationType = params.invitationType
            processParams.userIds = params.memberIdList
        }
        return model.post('clazz/updateClazzPaper', processParams)
    }

    /**
     * 解散群组
     *
     * @param clazzId
     * @return
     */
    static updateClazzState(clazzId) {
        return model.post(`clazz/updateClazzState?clazzId=${clazzId}&resourceState=${ResourceState.DELETED}`)
    }

    /**
     * 退出群组
     *
     * @param clazzId
     * @return
     */
    static updateClazzUserOfSelf(clazzId) {
        return model.post(`clazz/updateClazzUserOfSelf?clazzId=${clazzId}&state=${ClazzUserState.OUT_BY_SELF}`)
    }

    /**
     * 修改/发布公告
     *
     * @param req
     * @return
     */
    static saveClazzNotice(req) {
        return model.post('clazz/saveClazzNotice', req)
    }

    /**
     * 提升为管理员
     *
     * @param opt
     * @return
     */
    static updateClazzMember(opt) {
        return model.post('clazz/updateClazzMember', opt)
    }

    /**
     * 移交群主
     *
     * @param clazzId
     * @param ownerId
     * @return
     */
    static updateClazzOwner(clazzId, ownerId) {
        return model.post(`clazz/updateClazzOwner?clazzId=${clazzId}&ownerId=${ownerId}`)
    }

    /**
     * 获取群组通知
     *
     * @param opts
     * @return
     */
    static getPendingClazzUsers(opts) {
        return model.post('clazz/getPendingClazzUsers', opts)
    }

    /**
     * 同意/拒绝加入群组
     *
     * @param clazzId
     * @param userId
     * @param state
     * @return
     */
    static updateClazzUserState(clazzId, userId, state) {
        return model.post(`clazz/updateClazzUserState?clazzId=${clazzId}&userId=${userId}&state=${state}`)
    }

    /**
     * 群组添加成员
     * @param clazzId 群组id
     * @param params 用户信息
     * @returns {*}
     */
    static saveClazzMember(clazzId, params) {
        return model.post(`clazz/saveClazzMember?clazzId=${clazzId}`, params)
    }

    /**
     * 群组添加成员 (批量)
     * @param clazzId 群组 id
     * @param userIdList 用户 id list
     * @returns {*}
     */
    static saveClazzMembers(clazzId, userIdList) {
        return model.post(`clazz/saveClazzMembers?clazzId=${clazzId}`, userIdList)
    }

    /**
     * 获取作业已邀请的人员
     * @param clazzId 群组 id
     * @param paperId 作业(试卷) id
     * @returns {*}
     */
    static getClazzPaperMembers(clazzId, paperId) {
        return model.post(`clazz/getClazzPaperInvitations?clazzId=${clazzId}&paperId=${paperId}`)
    }

    /**
     * 点赞
     * @param testId
     * @returns {*}
     */
    static like(testId) {
        return model.post(`clazz/savePaperReportPraise?testId=${testId}`)
    }

}
export default Clazz



// WEBPACK FOOTER //
// ./bootsets/models/clazz.js